import React from 'react'
import { motion } from 'framer-motion'

const reasons = [
  {
    title: "Expert Quality",
    description: "Professional results with attention to every detail",
    bar: "bg-orange-500",
    hover: "hover:border-orange-300 hover:shadow-orange-100",
  },
  {
    title: "Fast Turnaround",
    description: "Quick delivery without compromising quality",
    bar: "bg-amber-500",
    hover: "hover:border-amber-300 hover:shadow-amber-100",
  },
  {
    title: "Affordable Pricing",
    description: "Competitive rates for professional services",
    bar: "bg-red-500",
    hover: "hover:border-red-300 hover:shadow-red-100",
  },
  {
    title: "24/7 Support",
    description: "Always here to help with your projects",
    bar: "bg-rose-500",
    hover: "hover:border-rose-300 hover:shadow-rose-100",
  },
]

const WhyChooseUs = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24 md:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -left-24 h-96 w-96 rounded-full bg-amber-200/40 blur-3xl"
      />

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 md:mb-20 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end"
        >
          <h2 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-[1.02] text-slate-900">
            Why Choose{' '}
            <span className="bg-gradient-to-r from-orange-500 via-red-500 to-amber-500 bg-clip-text text-transparent">
              Us
            </span>
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            We provide exceptional service with a focus on quality, speed, and customer satisfaction.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reasons.map((reason, index) => (
            <motion.div
              key={reason.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 pt-10 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl ${reason.hover}`}
            >
              <div className={`absolute left-0 top-0 h-1.5 w-full ${reason.bar}`} />
              <h3 className="text-2xl font-bold tracking-tight text-slate-900 mb-3">
                {reason.title}
              </h3>
              <div className="mb-4 border-t border-dashed border-slate-300" />
              <p className="text-slate-600 leading-relaxed">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs